import React, {useEffect, useState} from "react";
import TitleSection from "./TitleSection";
import styled from "styled-components";
import Actions from "../../action/Actions";
import {useSelector} from "react-redux";
import {getDateInFrench} from "../../../utils/dateUtils";
import ToggleGanttListButton from "../../buttons/ToggleGanttListButton";
import useToggleView from "../../../custom-hooks/useToggleView";
import Gantt from "../../gantt/Gantt";

const ActionsSection = ({toggleHandler}) => {

    const {actions, id} = useSelector(state => state.project)

    const [lastUpdate, setLastUpdate] = useState()
    const {projectHistory} = useSelector(state => state.projectHistory)
    const {listView, toggleGantView, toggleListView, ganttView} = useToggleView()

    useEffect(() => {
        const lastUpdateItems = projectHistory.filter(p => p.entityClass === "Action")
        if (lastUpdateItems.length > 0) {
            setLastUpdate(lastUpdateItems[0])
        }
    }, [projectHistory])


    return (
        <Container>
            <TitleSection
                title={"Actions"}
                toggleHandler={toggleHandler}
            />
            <P> Dernière mise à jour
                : {lastUpdate ? getDateInFrench(lastUpdate.dateOfModification) : "Aucune modification"}</P>

            <ToggleGanttListButton
                toggleListView={toggleListView}
                toggleGantView={toggleGantView}
                listView={listView}
                ganttView={ganttView}
            />
            {ganttView &&
            <Gantt
                projectId={id}/>
            }
            {listView &&
            <Actions
                actions={actions}
                projectId={id}
                inActionPage={false}
            />
            }
        </Container>
    )
}

const Container = styled.div`
  height: 100%;
  width: 100%;
`

const P = styled.p`
  text-align: center;
  margin-bottom: 1rem;
`

export default ActionsSection